export default "__VITE_ASSET__CbyfcTKe__"